import styles from "styles/Header.module.scss";
import { Link } from "react-router-dom";
import GetIcon from "components/GetIcon";
import clsx from "clsx";
import CategoryItem from "./CategoryItem";
import useMakeRequest from "hooks/useMakeRequest";
import { useContext, useState } from "react";
import { BasketContext } from "context/BasketContext";
import logo from 'images/logo.png';
import config from "../config";

const Header = () => {
    const result = useMakeRequest(`${config.API_BASE_URL}/products/categories`);
    const { basketItems, setBasketIsOpen } = useContext(BasketContext);

    // State to control the visibility of the categories dropdown
    const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);

    // Function to toggle categories dropdown visibility
    const toggleCategories = (state) => {
        setIsCategoriesOpen(state);
    };

    return (
        <header className={styles.header}>
            <div className={styles.logo}>
                <Link to="/Shop">
                    <img style={{ marginRight: '10px' }} src={logo} alt="Muscle Factory Logo" width="120" height="120" />
                </Link>
                <Link to="/Shop">
                    <h1>Muscle Factory</h1>
                </Link>
            </div>
            <div className={styles.navContainer}>
                <nav className={styles.nav}>
                    <ul>
                        <li>
                            <Link to="/Shop" className={styles.a}>
                                Tienda
                            </Link>
                        </li>
                        <li>
                            <Link to="/About" className={styles.a}>
                                Sobre Nosotros
                            </Link>
                        </li>
                        <li>
                            <Link to="/Gallery" className={styles.a}>
                                Galleria
                            </Link>
                        </li>
                        <li
                            onMouseEnter={() => toggleCategories(true)}
                            onMouseLeave={() => toggleCategories(false)}
                        >
                            <Link
                                to="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleCategories(!isCategoriesOpen); // Toggle visibility on click
                                }}
                                className={styles.a}
                            >
                                Categorías
                            </Link>
                            <ul
                                className={styles.subMenu}
                                style={{
                                    visibility: isCategoriesOpen ? 'visible' : 'hidden',
                                    opacity: isCategoriesOpen ? 1 : 0,
                                }}
                            >
                                {result.data
                                    ? result.data.map((cat, index) => (
                                        <CategoryItem data={cat} key={index} />
                                    ))
                                    : <div>{result.error}</div>}
                            </ul>
                        </li>
                        <li>
                            <Link
                                to="/"
                                className={clsx(styles.basketBtn, styles.a)}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setBasketIsOpen((oldState) => !oldState);
                                }}
                            >
                                <GetIcon icon="BsCart4" size={25} color="#ffffff" />
                                {basketItems.length > 0 && <span className={styles.basketLength}> {basketItems.length} </span>}
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
